export const complectations = ({ complectations }) => complectations;
